export const overlay = document.getElementById('overlay');
export const terminal = document.getElementById('terminal');
